import './application/main'

import '../../vendor/assets/javascripts/jquery.counterup.min'
import '../../vendor/assets/javascripts/jquery.waypoints.min'
import '../../vendor/assets/javascripts/jquery-ui.min'
import '../../vendor/assets/javascripts/slick.min'
import '../../vendor/assets/javascripts/datepicker.min'
import 'vivus'
import 'lightslider'
import 'flatpickr'

import './application/baidu-map'
import './application/clipboard'
import './application/count'
import './application/forms'
import './application/header'
import './application/home'
import './application/map-leaf'
import './application/modal'
import './application/responsive'
import './application/scrollAnim'
import './application/slider'
import './application/smoothScroll'
import './application/stores'
import './application/timeline'
